import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const manifestFieldTypes = [
    "NAME",
    // "ICE",
    // "FIRST_NAME",
    // "LAST_NAME",
    // "PHONE",
    // "EMAIL",
] as const;

const manifestFieldTypeZodSchema = z.enum(manifestFieldTypes);
type ManifestFieldType = z.infer<typeof manifestFieldTypeZodSchema>;
const manifestFieldType = toObjectMap<ManifestFieldType>([
    ...manifestFieldTypes,
]);

export { manifestFieldTypes, manifestFieldType, manifestFieldTypeZodSchema };
export type { ManifestFieldType };
